<template>
  <section ref="root" class="evento-lux">

    <!-- 🌸 FLORES -->
    <img src="@/assets/f.png" class="flor flor-1" alt="" />
    <img src="@/assets/f.png" class="flor flor-2" alt="" />

    <!-- 🌿 RAMAS -->
    <img src="@/assets/ramas.png" class="rama rama-izq" alt="" />

    <!-- 🦋 MARIPOSAS -->
    <img src="@/assets/mariposas.png" class="mariposa mariposa-1" alt="" />
    <img src="@/assets/mariposas.png" class="mariposa mariposa-2" alt="" />

    <!-- ===== TARJETA ===== -->
    <article ref="card2" class="card">
      <img class="icono" src="@/assets/10.avif" alt="" />
      <h3 class="titulo-script">Recepción</h3>
      <p class="hora">6:45 PM</p>
      <p class="lugar">Millenium Banquet Hall</p>
      <p class="direccion">14619 SW 42nd St, Miami, Florida 33175</p>

      <a
        ref="btn2"
        class="btn-rosa"
        href="https://maps.app.goo.gl/y4GK7s8k8pGBC2N36"
        target="_blank"
      >
        ¿Cómo llegar?
        <span class="sheen"></span>
      </a>
    </article>
  </section>

  <div class="lux-escena-final">
    <div class="lux-degradado"></div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'

export default {
    name: 'TuComponente',

  setup() {
    const root = ref(null)
    const card2 = ref(null)

    onMounted(() => {
      const $ = gsap.utils.selector(root.value)

      const flores = ['.flor-1', '.flor-2'].flatMap($)
      const ramas = ['.rama-izq'].flatMap($)
      const mariposas = ['.mariposa-1', '.mariposa-2'].flatMap($)

      const texto = gsap.utils.selector(card2.value)([
        '.icono',
        '.titulo-script',
        '.hora',
        '.lugar',
        '.direccion',
        '.btn-rosa'
      ])

      gsap.set([...flores, ...texto], { autoAlpha: 0, y: 28 })
      gsap.set(mariposas, { autoAlpha: 0, scale: 0.6, y: 40 })
      gsap.set(ramas, { autoAlpha: 0, scaleY: 0, transformOrigin: 'top center' })

      const io = new IntersectionObserver(entries => {
        if (!entries[0].isIntersecting) return

        const tl = gsap.timeline({ defaults: { ease: 'power2.out' } })

        tl.to(ramas, { autoAlpha: 1, scaleY: 1, duration: 0.9 })
          .to(flores, { autoAlpha: 1, y: 0, stagger: 0.12 }, '-=0.6')
          .to(mariposas, { autoAlpha: 1, y: 0, scale: 1, stagger: 0.12 }, '-=0.5')
          .to(texto, { autoAlpha: 1, y: 0, stagger: 0.08 }, '-=0.4')

        io.disconnect()
      }, { threshold: 0.25 })

      io.observe(root.value)
    })

    return { root, card2 }
  }
}
</script>



<style scoped>


.evento-lux{
  position: relative;   /* 🔑 OBLIGATORIO */
  overflow: visible;    /* 🔑 OBLIGATORIO */
  padding: 28px 18px 64px;
 
  display: grid;
  place-items: center;
}

/* ===== TARJETA ===== */
.card{
  width: min(440px, 92vw);
  background: transparent;
  box-shadow: none;
  border: none !important;
  outline: none;
  padding: 24px 20px 28px;
  text-align: center;
  position: relative;
  z-index: 0;
}

.icono{
  width: 52px;
  margin: 0 auto 10px;
  opacity: .92;
}

.titulo-script{
  font-family: 'britishgruesa', cursive;
  font-size: 56px;
  margin: 4px 0 8px;
}

.hora{
  font-family: 'fa', sans-serif;
  font-size: 24px;
}

.lugar{
  font-family: 'padres', serif;
  font-size: 22px;
  letter-spacing: .14em;
}

.direccion{
  font-family: 'padres', serif;
  font-style: italic;
  font-size: 16px;
  font-weight: 600;
  color: var(--gris);
  margin-bottom: 16px;
}

/* ===== BOTÓN ===== */
.btn-rosa{
  position: relative;
  padding: 11px 20px;
  border-radius: 14px;
  background: #7c9183;
  color: #fff;
  text-decoration: none;
  font-family: 'padres', sans-serif;
  font-weight: 800;
  box-shadow: 0 8px 16px rgba(0,0,0,.12);
}

.btn-rosa .sheen{
  position: absolute;
  top: -30%;
  left: -30%;
  width: 60%;
  height: 160%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,.6), transparent);
  transform: rotate(20deg);
  opacity: 0;
}

/* ===== ESCENA FINAL ===== */
.lux-escena-final{
  width: 100%;
  margin-top: 8px;
}








/* 🌸 FLORES */
.flor{
  position: absolute;
  width: 120px;
  opacity: .9;
  pointer-events: none;
}
.flor-1{ top: 40px; left: -20px; }
.flor-2{ bottom: 40px; right: -20px; }

/* 🌿 RAMAS */
.rama{
  position: absolute;
  top: 0;
  right: -40px;
  width: 180px;
  pointer-events: none;
}

/* 🦋 MARIPOSAS */
.mariposa{
  position: absolute;
  width: 42px;
  pointer-events: none;
}
.mariposa-1{ bottom: 120px; left: 30%; }
.mariposa-2{ bottom: 140px; right: 28%; }

/* 🌸 FLORES */
.flor{
  position: absolute;
  width: 120px;
  z-index: 2;
  pointer-events: none;
}
.flor-1{ top: 630px; left: -30px; }
.flor-2{ top: -40px; right: -30px; }

/* 🌿 RAMAS */
.rama{
  position: absolute;
  top: -10px;
  right: -40px;
  width: 100px;
  z-index: 1;
  pointer-events: none;
}

/* 🦋 MARIPOSAS */
.mariposa{
  position: absolute;
  width: 82px;
  z-index: 4;
  pointer-events: none;
}
.mariposa-1{ top: -30px; right: 92%; }
.mariposa-2{ bottom: 140px; right: 90%; }
</style>
